import { mysqlTable, index, primaryKey, int, varchar, tinyint, text, datetime, unique, mediumint, smallint, date, double, decimal, char, bigint } from 'drizzle-orm/mysql-core';

export const bankAccount = mysqlTable(
  'bank_account',
  {
    memberId: int('member_id', { unsigned: true }).notNull(),
    bankCode: varchar('bank_code', { length: 255 }).notNull(),
    branchCode: varchar('branch_code', { length: 255 }).notNull(),
    bankName: varchar('bank_name', { length: 255 }).notNull(),
    branchName: varchar('branch_name', { length: 255 }).notNull(),
    accountNumber: varchar('account_number', { length: 255 }).notNull(),
    accountType: tinyint('account_type', { unsigned: true }).notNull(),
    accountName: text('account_name').notNull(),
    createdAt: datetime('created_at', { mode: 'string' }).notNull(),
    updatedAt: datetime('updated_at', { mode: 'string' }).notNull(),
  },
  (table) => [index('fk_bank_account_member1').on(table.memberId), primaryKey({ columns: [table.memberId], name: 'bank_account_member_id' })],
);

export const category = mysqlTable(
  'category',
  {
    categoryId: mediumint('category_id', { unsigned: true }).notNull(),
    slug: varchar({ length: 31 }).notNull(),
    parentCategoryId: mediumint('parent_category_id').notNull(),
    sort: smallint({ unsigned: true }).notNull(),
    createdAt: datetime('created_at', { mode: 'string' }).notNull(),
    updatedAt: datetime('updated_at', { mode: 'string' }).notNull(),
  },
  (table) => [
    index('fk_category_category1').on(table.parentCategoryId),
    index('ix_category_1').on(table.parentCategoryId, table.sort, table.categoryId),
    primaryKey({ columns: [table.categoryId], name: 'category_category_id' }),
    unique('uq_category_1').on(table.parentCategoryId, table.slug),
  ],
);

export const categoryI18N = mysqlTable(
  'category_i18n',
  {
    categoryId: mediumint('category_id').notNull(),
    culture: varchar({ length: 7 }).notNull(),
    name: varchar({ length: 31 }).notNull(),
    shortName: varchar('short_name', { length: 31 }).notNull(),
    description: text().notNull(),
  },
  (table) => [index('fk_category_i18n_category1').on(table.categoryId), primaryKey({ columns: [table.categoryId, table.culture], name: 'category_i18n_category_id_culture' })],
);

export const color = mysqlTable(
  'color',
  {
    colorId: int('color_id').notNull(),
    slug: varchar({ length: 31 }).notNull(),
    name: varchar({ length: 31 }).notNull(),
  },
  (table) => [primaryKey({ columns: [table.colorId], name: 'color_color_id' })],
);

export const email = mysqlTable(
  'email',
  {
    emailId: int('email_id', { unsigned: true }).autoincrement().notNull(),
    host: varchar({ length: 255 }).notNull(),
    address: varchar({ length: 255 }).notNull(),
    reachable: tinyint().default(1).notNull(),
    available: tinyint().default(1).notNull(),
    updatedAt: datetime('updated_at', { mode: 'string' }).notNull(),
    createdAt: datetime('created_at', { mode: 'string' }).notNull(),
  },
  (table) => [index('ix_email_host').on(table.host), primaryKey({ columns: [table.emailId], name: 'email_email_id' }), unique('address_UNIQUE').on(table.address)],
);

export const emailSubscribedArrivalNotification = mysqlTable(
  'email_subscribed_arrival_notification',
  {
    emailId: int('email_id', { unsigned: true }).notNull(),
    itemId: int('item_id', { unsigned: true }).notNull(),
    createdAt: datetime('created_at', { mode: 'string' }).notNull(),
  },
  (table) => [index('ix_email_subscribed_arrival_notification_item_id').on(table.itemId), primaryKey({ columns: [table.emailId, table.itemId], name: 'email_subscribed_arrival_notification_email_id_item_id' })],
);

export const event = mysqlTable(
  'event',
  {
    eventId: int('event_id', { unsigned: true }).autoincrement().notNull(),
    promoterId: int('promoter_id', { unsigned: true }).notNull(),
    slug: varchar({ length: 31 }).notNull(),
    title: varchar({ length: 255 }).notNull(),
    description: text().notNull(),
    url: varchar({ length: 255 }).notNull(),
    zipcode: varchar({ length: 15 }).notNull(),
    prefecture: varchar({ length: 15 }).notNull(),
    address: varchar({ length: 255 }).notNull(),
    venue: varchar({ length: 127 }).notNull(),
    // you can use { mode: 'date' }, if you want to have Date as type for this column
    startAt: date('start_at', { mode: 'string' }).notNull(),
    // you can use { mode: 'date' }, if you want to have Date as type for this column
    endAt: date('end_at', { mode: 'string' }).notNull(),
    scheduleComment: varchar('schedule_comment', { length: 255 }).notNull(),
    published: tinyint({ unsigned: true }).default(0).notNull(),
    contact: varchar({ length: 255 }).notNull(),
    createdAt: datetime('created_at', { mode: 'string' }).notNull(),
    updatedAt: datetime('updated_at', { mode: 'string' }).notNull(),
  },
  (table) => [index('ix_event_1').on(table.published, table.startAt, table.endAt), index('fk_event_promoter1').on(table.promoterId), primaryKey({ columns: [table.eventId], name: 'event_event_id' }), unique('uq_event_1').on(table.slug)],
);

export const featureShop = mysqlTable(
  'feature_shop',
  {
    shopId: int('shop_id', { unsigned: true }).notNull(),
    createdAt: datetime('created_at', { mode: 'string' }).notNull(),
    updatedAt: datetime('updated_at', { mode: 'string' }).notNull(),
  },
  (table) => [primaryKey({ columns: [table.shopId], name: 'feature_shop_shop_id' })],
);

export const item = mysqlTable(
  'item',
  {
    itemId: int('item_id', { unsigned: true }).autoincrement().notNull(),
    shopId: int('shop_id', { unsigned: true }).notNull(),
    categoryId: mediumint('category_id').notNull(),
    slug: varchar({ length: 255 }).notNull(),
    price: double().notNull(),
    currency: varchar({ length: 3 }).default('USD').notNull(),
    height: decimal({ precision: 5, scale: 2, unsigned: true }).default('0.00').notNull(),
    width: decimal({ precision: 5, scale: 2, unsigned: true }).default('0.00').notNull(),
    depth: decimal({ precision: 5, scale: 2, unsigned: true }).default('0.00').notNull(),
    stock: smallint({ unsigned: true }).notNull(),
    soldStock: smallint('sold_stock', { unsigned: true }).notNull(),
    weight: mediumint({ unsigned: true }).notNull(),
    orderInShop: double('order_in_shop', { unsigned: true }).notNull(),
    iichiShippingFee: mediumint('iichi_shipping_fee', { unsigned: true }).notNull(),
    published: tinyint().default(0).notNull(),
    isAvailableOverseas: tinyint('is_available_overseas').default(0).notNull(),
    deleted: tinyint().default(0).notNull(),
    publishedAt: datetime('published_at', { mode: 'string' }).notNull(),
    overseasPublishedAt: datetime('overseas_published_at', { mode: 'string' }).notNull(),
    likeCount: int('like_count').default(0).notNull(),
    state: varchar({ length: 255 }).default('').notNull(),
    pv: int({ unsigned: true }).default(0).notNull(),
    isGift: tinyint('is_gift').default(0).notNull(),
    isOrdermade: tinyint('is_ordermade').default(0).notNull(),
    isEspecial: tinyint('is_especial').default(0).notNull(),
    createdAt: datetime('created_at', { mode: 'string' }).notNull(),
    updatedAt: datetime('updated_at', { mode: 'string' }).notNull(),
  },
  (table) => [
    index('fk_item_category1').on(table.categoryId),
    index('ix_item_4').on(table.published, table.deleted, table.price),
    index('ix_item_9').on(table.shopId, table.published, table.deleted, table.orderInShop),
    primaryKey({ columns: [table.itemId], name: 'item_item_id' }),
  ],
);

export const itemCategory = mysqlTable(
  'item_category',
  {
    itemId: int('item_id', { unsigned: true }).notNull(),
    categoryId: mediumint('category_id').notNull(),
    rank: tinyint({ unsigned: true }).default(0).notNull(),
    hierarchy: tinyint({ unsigned: true }).notNull(),
    optionalName: varchar('optional_name', { length: 31 }).notNull(),
    createdAt: datetime('created_at', { mode: 'string' }).notNull(),
    updatedAt: datetime('updated_at', { mode: 'string' }).notNull(),
  },
  (table) => [
    index('fk_item_category_item1').on(table.itemId),
    index('fk_item_category_category1').on(table.categoryId),
    index('ix_item_category_1').on(table.itemId, table.hierarchy),
    primaryKey({ columns: [table.itemId, table.categoryId], name: 'item_category_item_id_category_id' }),
  ],
);

export const itemColor = mysqlTable(
  'item_color',
  {
    itemId: int('item_id', { unsigned: true }).notNull(),
    colorId: int('color_id').notNull(),
    createdAt: datetime('created_at', { mode: 'string' }).notNull(),
    updatedAt: datetime('updated_at', { mode: 'string' }).notNull(),
  },
  (table) => [index('fk_item_color_color1_idx').on(table.colorId), primaryKey({ columns: [table.itemId, table.colorId], name: 'item_color_item_id_color_id' })],
);

export const itemI18N = mysqlTable(
  'item_i18n',
  {
    itemId: int('item_id', { unsigned: true }).notNull(),
    culture: varchar({ length: 7 }).notNull(),
    title: varchar({ length: 255 }).notNull(),
    translated: tinyint({ unsigned: true }).default(0).notNull(),
    description: text().notNull(),
    aboutShipping: text('about_shipping').notNull(),
    craftPeriod: smallint('craft_period', { unsigned: true }).notNull(),
    aboutCraftPeriod: varchar('about_craft_period', { length: 1023 }).notNull(),
    remark: varchar({ length: 1023 }).notNull(),
  },
  (table) => [index('fk_item_i18n_item1').on(table.itemId), primaryKey({ columns: [table.itemId, table.culture], name: 'item_i18n_item_id_culture' })],
);

export const itemListingFirstLastHistory = mysqlTable(
  'item_listing_first_last_history',
  {
    itemId: int('item_id', { unsigned: true }).notNull(),
    firstListedAt: datetime('first_listed_at', { mode: 'string' }).notNull(),
    lastListedAt: datetime('last_listed_at', { mode: 'string' }).notNull(),
  },
  (table) => [
    index('ix_item_listing_first_last_history').on(table.itemId, table.lastListedAt),
    index('ix_item_listing_first_last_history_2').on(table.lastListedAt),
    primaryKey({ columns: [table.itemId], name: 'item_listing_first_last_history_item_id' }),
  ],
);

export const itemMaterial = mysqlTable(
  'item_material',
  {
    itemId: int('item_id', { unsigned: true }).notNull(),
    materialId: int('material_id', { unsigned: true }).notNull(),
    optionalName: varchar('optional_name', { length: 31 }).notNull(),
    createdAt: datetime('created_at', { mode: 'string' }).notNull(),
    updatedAt: datetime('updated_at', { mode: 'string' }).notNull(),
  },
  (table) => [index('fk_item_material_item1').on(table.itemId), index('fk_item_material_material1').on(table.materialId), primaryKey({ columns: [table.itemId, table.materialId], name: 'item_material_item_id_material_id' })],
);

export const itemMeta = mysqlTable(
  'item_meta',
  {
    itemId: int('item_id', { unsigned: true }).notNull(),
    metaId: smallint('meta_id', { unsigned: true }).notNull(),
    value: varchar({ length: 255 }).notNull(),
    createdAt: datetime('created_at', { mode: 'string' }).notNull(),
    updatedAt: datetime('updated_at', { mode: 'string' }).notNull(),
  },
  (table) => [index('ix_item_meta_meta_id').on(table.metaId), primaryKey({ columns: [table.itemId, table.metaId], name: 'item_meta_item_id_meta_id' })],
);

export const itemOfShopArtist = mysqlTable(
  'item_of_shop_artist',
  {
    itemId: int('item_id', { unsigned: true }).notNull(),
    shopArtistId: int('shop_artist_id', { unsigned: true }).notNull(),
    shopId: int('shop_id', { unsigned: true }).notNull(),
    createdAt: datetime('created_at', { mode: 'string' }).notNull(),
  },
  (table) => [index('fk_maker_item_shop1').on(table.shopId), index('ix_item_of_shop_artist_shop_artist_id').on(table.shopArtistId), primaryKey({ columns: [table.itemId], name: 'item_of_shop_artist_item_id' })],
);

export const itemOption = mysqlTable(
  'item_option',
  {
    itemOptionSlug: char('item_option_slug', { length: 8 }).notNull(),
    shopId: int('shop_id', { unsigned: true }).notNull(),
    name: varchar({ length: 31 }).notNull(),
    required: tinyint().notNull(),
    order: tinyint({ unsigned: true }).notNull(),
    createdAt: datetime('created_at', { mode: 'string' }).notNull(),
    updatedAt: datetime('updated_at', { mode: 'string' }).notNull(),
  },
  (table) => [index('ix_item_option_shop_id').on(table.shopId), primaryKey({ columns: [table.itemOptionSlug], name: 'item_option_item_option_slug' })],
);

export const itemOptionOfItem = mysqlTable(
  'item_option_of_item',
  {
    itemOptionSlug: char('item_option_slug', { length: 8 })
      .notNull()
      .references(() => itemOption.itemOptionSlug, { onDelete: 'cascade' }),
    itemId: int('item_id', { unsigned: true }).notNull(),
    order: tinyint({ unsigned: true }).notNull(),
    createdAt: datetime('created_at', { mode: 'string' }).notNull(),
    updatedAt: datetime('updated_at', { mode: 'string' }).notNull(),
  },
  (table) => [index('ix_item_option_of_item_item_id_order').on(table.itemId, table.order), primaryKey({ columns: [table.itemOptionSlug, table.itemId], name: 'item_option_of_item_item_option_slug_item_id' })],
);

export const itemOptionVariant = mysqlTable(
  'item_option_variant',
  {
    itemOptionVariantSlug: char('item_option_variant_slug', { length: 8 }).notNull(),
    itemOptionSlug: char('item_option_slug', { length: 8 })
      .notNull()
      .references(() => itemOption.itemOptionSlug, { onDelete: 'cascade' }),
    name: varchar({ length: 31 }).notNull(),
    price: int({ unsigned: true }).notNull(),
    order: tinyint({ unsigned: true }).notNull(),
    createdAt: datetime('created_at', { mode: 'string' }).notNull(),
    updatedAt: datetime('updated_at', { mode: 'string' }).notNull(),
  },
  (table) => [primaryKey({ columns: [table.itemOptionVariantSlug], name: 'item_option_variant_item_option_variant_slug' })],
);

export const itemPicture = mysqlTable(
  'item_picture',
  {
    itemId: int('item_id', { unsigned: true }).notNull(),
    order: tinyint({ unsigned: true }).notNull(),
    slug: varchar({ length: 31 }).notNull(),
    contentType: varchar('content_type', { length: 15 }).notNull(),
    text: text().notNull(),
    width: smallint({ unsigned: true }).notNull(),
    height: smallint({ unsigned: true }).notNull(),
    createdAt: datetime('created_at', { mode: 'string' }).notNull(),
    updatedAt: datetime('updated_at', { mode: 'string' }).notNull(),
  },
  (table) => [index('fk_item_picture_item1').on(table.itemId), index('ix_item_picture_1').on(table.itemId, table.order), primaryKey({ columns: [table.itemId, table.order], name: 'item_picture_item_id_order' })],
);

export const itemViewHistory = mysqlTable(
  'item_view_history',
  {
    itemViewHistoryId: bigint('item_view_history_id', { mode: 'number', unsigned: true }).autoincrement().notNull(),
    itemId: int('item_id', { unsigned: true }).notNull(),
    memberId: int('member_id', { unsigned: true }).notNull(),
    createdAt: datetime('created_at', { mode: 'string' }).notNull(),
  },
  (table) => [index('ix_item_view_history').on(table.memberId, table.createdAt), primaryKey({ columns: [table.itemViewHistoryId, table.createdAt], name: 'item_view_history_item_view_history_id_created_at' })],
);

export const likeness = mysqlTable(
  'likeness',
  {
    likenessId: bigint('likeness_id', { mode: 'number', unsigned: true }).autoincrement().notNull(),
    memberId: int('member_id', { unsigned: true }).notNull(),
    linkId: int('link_id', { unsigned: true }).notNull(),
    type: smallint({ unsigned: true }).notNull(),
    createdAt: datetime('created_at', { mode: 'string' }).notNull(),
    updatedAt: datetime('updated_at', { mode: 'string' }).notNull(),
  },
  (table) => [
    index('fk_favorite_member1').on(table.memberId),
    index('ix_likeness_1').on(table.memberId, table.type),
    index('ix_likeness_3').on(table.type, table.linkId),
    index('ix_likeness_type_created_at').on(table.type, table.createdAt),
    primaryKey({ columns: [table.likenessId], name: 'likeness_likeness_id' }),
    unique('uq_likeness_1').on(table.memberId, table.linkId, table.type),
  ],
);

export const likenessItem = mysqlTable(
  'likeness_item',
  {
    itemId: int('item_id', { unsigned: true }).notNull(),
    // you can use { mode: 'date' }, if you want to have Date as type for this column
    summaryDate: date('summary_date', { mode: 'string' }).notNull(),
    sort: int({ unsigned: true }).notNull(),
    createdAt: datetime('created_at', { mode: 'string' }).notNull(),
  },
  (table) => [
    index('fk_likeness_item_item1_idx').on(table.itemId),
    index('ix_likeness_item1').on(table.summaryDate),
    index('ix_likeness_item2').on(table.summaryDate, table.sort),
    primaryKey({ columns: [table.itemId, table.summaryDate], name: 'likeness_item_item_id_summary_date' }),
  ],
);

export const material = mysqlTable(
  'material',
  {
    materialId: int('material_id', { unsigned: true }).notNull(),
    slug: varchar({ length: 31 }).notNull(),
    createdAt: datetime('created_at', { mode: 'string' }).notNull(),
    updatedAt: datetime('updated_at', { mode: 'string' }).notNull(),
  },
  (table) => [index('ix_material_1').on(table.slug), primaryKey({ columns: [table.materialId], name: 'material_material_id' })],
);

export const materialI18N = mysqlTable(
  'material_i18n',
  {
    materialId: int('material_id', { unsigned: true }).notNull(),
    culture: varchar({ length: 7 }).notNull(),
    name: varchar({ length: 31 }).notNull(),
  },
  (table) => [index('fk_material_i18n_material1').on(table.materialId), primaryKey({ columns: [table.materialId, table.culture], name: 'material_i18n_material_id_culture' })],
);

export const member = mysqlTable(
  'member',
  {
    memberId: int('member_id', { unsigned: true }).autoincrement().notNull(),
    slug: varchar({ length: 31 }).notNull(),
    alias: varchar({ length: 255 }).notNull(),
    email: varchar({ length: 255 }).notNull(),
    password: varchar({ length: 255 }).notNull(),
    emailConfirmed: tinyint('email_confirmed').default(0).notNull(),
    emailSuspended: tinyint('email_suspended').default(0).notNull(),
    emailBounceCount: int('email_bounce_count', { unsigned: true }).default(0).notNull(),
    defaultCulture: char('default_culture', { length: 5 }).notNull(),
    defaultCurrency: char('default_currency', { length: 3 }).notNull(),
    likeCount: mediumint('like_count', { unsigned: true }).notNull(),
    deleted: tinyint().default(0).notNull(),
    createdAt: datetime('created_at', { mode: 'string' }).notNull(),
    updatedAt: datetime('updated_at', { mode: 'string' }).notNull(),
  },
  (table) => [
    index('ix_member_1').on(table.alias, table.deleted),
    index('ix_member_2').on(table.slug),
    index('ix_member_3').on(table.deleted, table.email),
    primaryKey({ columns: [table.memberId], name: 'member_member_id' }),
    unique('email_UNIQUE').on(table.email),
  ],
);

export const memberI18N = mysqlTable(
  'member_i18n',
  {
    memberId: int('member_id', { unsigned: true }).notNull(),
    culture: varchar({ length: 7 }).notNull(),
    memberName: varchar('member_name', { length: 255 }).notNull(),
    about: text().notNull(),
  },
  (table) => [index('fk_member_i18n_member1').on(table.memberId), primaryKey({ columns: [table.memberId, table.culture], name: 'member_i18n_member_id_culture' })],
);

export const memberPicture = mysqlTable(
  'member_picture',
  {
    memberId: int('member_id', { unsigned: true }).notNull(),
    slug: varchar({ length: 31 }).notNull(),
    contentType: varchar('content_type', { length: 15 }).notNull(),
    createdAt: datetime('created_at', { mode: 'string' }).notNull(),
    updatedAt: datetime('updated_at', { mode: 'string' }).notNull(),
  },
  (table) => [index('fk_member_picture_member1').on(table.memberId), primaryKey({ columns: [table.memberId], name: 'member_picture_member_id' })],
);

export const newsletterSubscription = mysqlTable(
  'newsletter_subscription',
  {
    newsletterSubscriptionId: int('newsletter_subscription_id', { unsigned: true }).autoincrement().notNull(),
    email: varchar({ length: 255 }).notNull(),
    culture: varchar({ length: 7 }).default('ja').notNull(),
    deleted: tinyint().default(0).notNull(),
    createdAt: datetime('created_at', { mode: 'string' }).notNull(),
    updatedAt: datetime('updated_at', { mode: 'string' }).notNull(),
  },
  (table) => [index('ix_newsletter_subscription_1').on(table.deleted, table.email), primaryKey({ columns: [table.newsletterSubscriptionId], name: 'newsletter_subscription_newsletter_subscription_id' })],
);

export const orderItem = mysqlTable(
  'order_item',
  {
    orderId: bigint('order_id', { mode: 'number', unsigned: true }).notNull(),
    itemId: int('item_id', { unsigned: true }).notNull(),
    quantity: smallint({ unsigned: true }).notNull(),
    price: int({ unsigned: true }).notNull(),
    currency: char({ length: 3 }).notNull(),
    shippingFee: int('shipping_fee', { unsigned: true }).notNull(),
    status: tinyint({ unsigned: true }).notNull(),
    createdAt: datetime('created_at', { mode: 'string' }).notNull(),
    updatedAt: datetime('updated_at', { mode: 'string' }).notNull(),
  },
  (table) => [index('fk_order_item_order1').on(table.orderId), index('fk_order_item_item1').on(table.itemId), primaryKey({ columns: [table.orderId, table.itemId], name: 'order_item_order_id_item_id' })],
);

export const shop = mysqlTable(
  'shop',
  {
    shopId: int('shop_id', { unsigned: true }).notNull(),
    slug: varchar({ length: 31 }).notNull(),
    alias: varchar({ length: 255 }).default('').notNull(),
    isAvailableOverseas: tinyint('is_available_overseas', { unsigned: true }).default(0).notNull(),
    isEspecial: tinyint('is_especial').default(0).notNull(),
    especialPath: varchar('especial_path', { length: 127 }).notNull(),
    likeCount: int('like_count').default(0).notNull(),
    listingItemCount: mediumint('listing_item_count', { unsigned: true }).notNull(),
    hasPinkoiShop: tinyint('has_pinkoi_shop').default(0).notNull(),
    listedAt: datetime('listed_at', { mode: 'string' }).notNull(),
    createdAt: datetime('created_at', { mode: 'string' }).notNull(),
    updatedAt: datetime('updated_at', { mode: 'string' }).notNull(),
  },
  (table) => [index('ix_shop_1').on(table.slug), index('ix_shop_alias').on(table.alias), primaryKey({ columns: [table.shopId], name: 'shop_shop_id' })],
);

export const shopArtist = mysqlTable(
  'shop_artist',
  {
    shopArtistId: int('shop_artist_id', { unsigned: true }).autoincrement().notNull(),
    shopId: int('shop_id', { unsigned: true }).notNull(),
    slug: varchar({ length: 31 }).notNull(),
    name: varchar({ length: 255 }).notNull(),
    description: text().notNull(),
    order: smallint({ unsigned: true }).notNull(),
    createdAt: datetime('created_at', { mode: 'string' }).notNull(),
    updatedAt: datetime('updated_at', { mode: 'string' }).notNull(),
  },
  (table) => [index('ix_shop_artist_1').on(table.shopId), primaryKey({ columns: [table.shopArtistId], name: 'shop_artist_shop_artist_id' })],
);

export const tag = mysqlTable(
  'tag',
  {
    tagId: int('tag_id', { unsigned: true }).autoincrement().notNull(),
    tag: varchar({ length: 31 }).notNull(),
    createdAt: datetime('created_at', { mode: 'string' }).notNull(),
    updatedAt: datetime('updated_at', { mode: 'string' }).notNull(),
  },
  (table) => [index('ix_tag_1').on(table.tag), primaryKey({ columns: [table.tagId], name: 'tag_tag_id' })],
);

export const tagOfItem = mysqlTable(
  'tag_of_item',
  {
    tagId: int('tag_id', { unsigned: true }).notNull(),
    itemId: int('item_id', { unsigned: true }).notNull(),
    shopId: int('shop_id', { unsigned: true }).notNull(),
    sort: smallint({ unsigned: true }).notNull(),
    createdAt: datetime('created_at', { mode: 'string' }).notNull(),
  },
  (table) => [index('ix_tag_of_item_item_id_sort').on(table.itemId, table.sort), primaryKey({ columns: [table.tagId, table.itemId], name: 'tag_of_item_tag_id_item_id' })],
);
